import React, { createContext, useEffect, useState } from "react";
import celebritiesRaw from "./celebrities.json";

const TheContext = createContext([]);

function TheContextProvider(props) {
  const [celebrities, setCelebrities] = useState([]);
  const [expandedId, setExpandedId] = useState(false);
  const [editCelebId, setEditCelebId] = useState(false);

  const changeExpandedId = (celebId) => (event, isExpanded) => {
    if (editCelebId !== false) {
      console.log("You cannot open another accordion while in edit mode");
      return;
    }
    setExpandedId(isExpanded ? celebId : false);
  };

  const deleteCeleb = (removeId) => {
    setCelebrities(celebrities.filter((celeb) => celeb.id !== removeId));
  };
  const updateCeleb = (celebId, updatedCeleb) => {
    const index = celebrities.findIndex((celeb) => celeb.id === celebId);
    celebrities[index] = updatedCeleb;
    setCelebrities(celebrities);
  };

  const getAge = (dob) => {
    let dobDate = new Date(dob);
    let month_diff = Date.now() - dobDate.getTime();
    let age_dt = new Date(month_diff);
    let year = age_dt.getUTCFullYear();
    let age = Math.abs(year - 1970);
    return age;
  };

  useEffect(() => {
    const celebArr = celebritiesRaw.map((celeb) => {
      return {
        id: celeb.id,
        name: celeb.first + " " + celeb.last,
        age: getAge(celeb.dob),
        gender: celeb.gender,
        picture: celeb.picture,
        country: celeb.country,
        description: celeb.description,
      };
    });
    setCelebrities(celebArr);
  }, []);

  return (
    <TheContext.Provider
      value={{
        expandedId,
        changeExpandedId,
        celebrities,
        editCelebId,
        setEditCelebId,
        deleteCeleb,
        updateCeleb,
      }}
    >
      {props.children}
    </TheContext.Provider>
  );
}
export { TheContext, TheContextProvider };
